import { NumberWithUnit, NumberWithUnitValue } from "@foodpilot/foods";
import { Box, Typography, useTheme } from "@mui/material";

type LeverIndicatorCardContentProps = {
    title: string;
    indicatorLabel: string;
    currentValue: NumberWithUnitValue;
    unit: string;
    currentValueColor?: string;
};

export const LeverIndicatorCardContent = (props: LeverIndicatorCardContentProps) => {
    const { title, indicatorLabel, currentValue, unit, currentValueColor } = props;
    const theme = useTheme();

    return (
        <>
            <Typography
                variant="h3"
                component="h3"
                sx={{
                    lineHeight: 1.35,
                    padding: theme.spacing(3.5, 3.5, 2),
                }}
            >
                {title}
            </Typography>
            <Typography
                component="span"
                variant="body-medium"
                sx={{
                    display: "block",
                    lineHeight: 1.45,
                    padding: theme.spacing(0, 3.5, 1),
                }}
            >
                {indicatorLabel}
            </Typography>
            <Box sx={{ padding: theme.spacing(0, 3.5, 3.5) }}>
                <NumberWithUnit
                    value={currentValue}
                    unit={unit}
                    size="big"
                    colorOverride={currentValueColor ?? theme.custom.grey[2500]}
                />
            </Box>
        </>
    );
};
